module.exports = __webpack_public_path__ + "carousel_03_img_01.png?b3cda80097525968841028098b669299";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel_03_img_01.png
// module id = 154
// module chunks = 0